<template>
    <figure
        class="BaseImage"
        :class="classes"
        :style="{'padding-bottom': keepRatio}"
    >
        <img
            class="lazyload image"
            :src="placeholder"
            :srcset="srcset"
            :sizes="sizes"
        />
        <div
            v-if="caption"
            class="BaseImage__caption"
        >
            {{ caption }}
        </div>
        <slot />
    </figure>
</template>
<script>
export default {
    name: 'BaseImage',
    props: {
        srcset: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        ratio: {
            type: Number,
            default: null
        },
        caption: {
            type: String,
            default: null
        },
        classes: {
            type: String,
            default: null
        },
        sizes: {
            type: String,
            default: '100vw'
        }
    },
    computed: {
        keepRatio() {
            return this.ratio ? 100 / this.ratio + '%' : null
        }
    }
}
</script>
<style lang="scss">

    .BaseImage {
        position: relative;
        background: $action-color;

        .image {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: block;
        }

        &.BaseImage--Cover {
            .image {
                object-fit: cover;
            }
        }

        &.BaseImage--ImageText  {
            .image {
                object-fit: cover;
            }

            @include media-query(lap-and-up) {
                width: 50%;
                padding-bottom: 50%!important;
                max-height: unset;
            }
        }

        &.BaseImage--ImageTextLong {
            .image {
                object-fit: cover;
            }

            @include media-query(lap-and-up) {
                width: 48%;
                padding-left: 2%;
            }
        }
    }

    .BaseImage__caption {
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: 1.25rem;
        right: 1.25rem;
        padding: 1.25rem;
        padding-left: 0;
        border-top: 1px solid getColor('white');
        font-weight: 700;
        color: getColor('white');
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.64px;
    }
</style>
